import { defineMessages } from 'react-intl-next';

export const i18n: {
	verifiedIconLabel: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	verifiedIconTooltipMessage: {
		defaultMessage: string;
		description: string;
		id: string;
	};
} = defineMessages({
	verifiedIconLabel: {
		id: 'search-page.verified-icon-label',
		defaultMessage: 'Verified',
		description:
			'Label for the verified icon shown as part of the metadata below the Confluence page title in the search results',
	},
	verifiedIconTooltipMessage: {
		id: 'search-page.verified-icon-tooltip-message',
		defaultMessage: 'This page has been verified by an owner or admin.',
		description: 'Tooltip message for the verified icon.',
	},
});
